import React from 'react';
import { graphql } from 'gatsby';
import { PromoBanner as PromoBannerComponent } from '../../../promoBanner/PromoBanner';

export const FullWidthPromoBanner = ({ data }) => (
  <PromoBannerComponent {...data} />
);

export const FullWidthPromoBannerQuery = graphql`
  fragment FullWidthPromoBanner on UMBRACO_FullWidthPromoBannerComponentType {
    heading
    link {
      ...Link
    }
  }
`;
